<div class="panel-complementario__seccion">
	<div class="opciones-adicionales__toggles" *ngIf="showCredEC || showIvaTerceros">
		<div class="opciones-adicionales__item" *ngIf="showCredEC">
			<ng-container *ngTemplateOutlet="credECTemplate"></ng-container>
		</div>
		<div class="opciones-adicionales__item" *ngIf="showIvaTerceros">
			<ng-container *ngTemplateOutlet="ivaTercerosTemplate"></ng-container>
		</div>
	</div>
	<div class="opciones-adicionales__acciones">
		<div class="opciones-adicionales__item" *ngIf="showMonedaButton">
			<button type="button" id="boton_moneda" class="btn btn-outline-primary opciones-adicionales__moneda-btn" (click)="monedaClick.emit()">
				<i class="fa-solid fa-money-bill-wave mr-2"></i>
				Moneda
			</button>
		</div>
		<div class="opciones-adicionales__item opciones-adicionales__tipo-pago">
			<label for="tipoPago">Condición de venta:</label>
			<input class="form-control" id="tipoPago" name="tipoPago" type="text" maxlength="50" [value]="tipoPago" (input)="tipoPagoChange.emit($any($event.target).value)" placeholder="Ej.: 30 días" />
		</div>
	</div>
</div>
